import {UrlLink} from '../../../applink/UrlLink';
import {t, tt} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {getGnbMenuActionName} from '../../../domain/menu/util/getGnbMenuActionName';
import {LOG_CLICK_EVENT, LOG_SEARCH_CLICK} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {Text} from '../../atoms/Text/Text';
import {IconWithDot} from '../../molecules/IconWithDot';
import {GnbSearchInputField} from '../GnbSearchInputField/GnbSearchInputField';
import {PcGnbMenuItem} from '../PcGnbMenuItem/PcGnbMenuItem';
import {ProfileImage} from '../ProfileImage/ProfileImage';
import {PcHeaderProps} from './PcHeaderProps.interface';

export function PcHeader({
  profileRef,
  gnbMenus,
  selectedPcGnbMenuId,
  keyword,
  onSubmitKeyword,
  onChangeKeyword,
  shouldShowUserThumbnail,
  userThumbnailUrl,
  onClickGift,
  onClickInven,
  onClickProfile,
  onClickKeywordRemoveButton,
  isGiftUpdated,
  onClickSearchInput,
  autoCompleteCustomProps,
  isMobile,
  className,
  ...props
}: PcHeaderProps) {
  return (
    <div
      className={twMerge(
        'flex h-pc_header_height_px w-1200pxr items-center px-30pxr',
        className
      )}
      {...props}
    >
      <UrlLink url={'/'} aria-label="카카오페이지 홈으로 이동, 버튼">
        <StaticImage
          imageType={StaticImageType.LogoBiTextL}
          className="h-24pxr w-110pxr"
          aria-hidden="true"
        />
      </UrlLink>
      <div className="ml-42pxr flex-1 items-center space-x-32pxr">
        {gnbMenus.map((menu, index) => (
          <UrlLink key={menu.id} url={menu.href}>
            <PcGnbMenuItem
              title={tt(menu)}
              isSelected={selectedPcGnbMenuId === menu.id}
              onClickCapture={e =>
                LOG_CLICK_EVENT(getGnbMenuActionName(menu.id), e)
              }
              {...putTiaraObjectProps({
                click: {
                  layer1: '홈메뉴',
                  ordnum: String(index + 1),
                },
              })}
            />
            <Text className="blind">
              {t('common_accessibility_order', {
                values: {
                  value: gnbMenus.length,
                  order: index + 1,
                },
              })}
            </Text>
          </UrlLink>
        ))}
      </div>
      <div
        className="mr-24pxr w-200pxr"
        {...putTiaraObjectProps({
          actionKind: 'Search',
          click: {
            copy: keyword,
          },
          search: {
            search_term: keyword,
            search_type: '입력검색어',
          },
          customProps: autoCompleteCustomProps,
        })}
      >
        <GnbSearchInputField
          value={keyword}
          onChange={onChangeKeyword}
          onSubmit={onSubmitKeyword}
          onClickRemoveButton={event =>
            LOG_SEARCH_CLICK('검색어삭제_클릭', event, () =>
              onClickKeywordRemoveButton()
            )
          }
          placeholder={t('search_before_input')}
          className="w-122pxr"
          onClick={event =>
            LOG_SEARCH_CLICK('검색박스_클릭', event, () =>
              onClickSearchInput?.(event)
            )
          }
          isMobile={isMobile}
        />
      </div>
      <div className="flex shrink-0 items-center justify-end space-x-24pxr">
        <button
          onClick={onClickInven}
          {...putTiaraObjectProps({
            click: {
              layer1: '숏컷',
            },
          })}
          aria-label="링크, 보관함"
        >
          <Icon type={IconType.NavigationCabinetWeb} />
        </button>
        <UrlLink url="/today-gift/0" aria-label="선물함, 버튼">
          <IconWithDot
            iconType={IconType.NavigationGiftWeb}
            isShowDot={isGiftUpdated}
            onClick={onClickGift}
            {...putTiaraObjectProps({
              click: {
                layer1: '숏컷',
              },
            })}
          />
        </UrlLink>
        {shouldShowUserThumbnail && (
          <button
            className="flex items-center"
            ref={profileRef}
            onClick={onClickProfile}
            aria-label="링크, 내 정보"
            {...putTiaraObjectProps({
              click: {
                layer1: '숏컷',
              },
            })}
          >
            <div className="h-24pxr w-24pxr cursor-pointer overflow-hidden rounded-full inner-line-theme-transparent-20 inner-line-rounded-full inner-line-0.5px">
              {userThumbnailUrl && (
                <ProfileImage thumbnailUrl={userThumbnailUrl} />
              )}
              {!userThumbnailUrl && (
                <StaticImage imageType={StaticImageType.ProfileStatic} />
              )}
            </div>
          </button>
        )}
        {!shouldShowUserThumbnail && (
          <button
            data-test="header-login-button"
            onClick={onClickProfile}
            aria-label="링크, 내 정보"
          >
            <Icon type={IconType.NavigationMyWeb} />
          </button>
        )}
      </div>
    </div>
  );
}
